const FormatNumber = (number: number) => {
	const formatter = new Intl.NumberFormat('en-US')

	return formatter.format(number).toString()
}

export default FormatNumber
